import React,{useEffect, useState,forwardRef,useImperativeHandle} from 'react'
import { Button,Form,Input,Select, InputNumber, Modal,Table,Space, message,Typography,Popconfirm  } from 'antd';
import type { TableProps } from 'antd';
import { produce } from 'immer'
import { nanoid } from 'nanoid'
import { activityCycleAndProductList, saveActivityCycleAndProduct,cycleProductType,selectProductType } from '@/services/activity';
import { ResDataType } from '@/services/ajax';
import { selectProductList } from '@/services/product';
import { DataType } from '../column';
import { debounce } from "@/utils"
import usePagAndCommon from '@/hooks/usePagAndCommon';
const { Text } = Typography;

interface tabDataType {
    productId: string;
    productName:string;
    inventory:number;
  }

 
  const ProductsContent = (props:any,ref:any) => {
    const { isModalOpen,setIsModalOpen } = usePagAndCommon();
    const [tipOpen,setTipOpen] = useState(false);
    const [costPriceTotal, setCostPriceTotal] = useState<number>(0);
    const [periods,setPeriods] = useState<any[]>([]);
    const [costPriceList,setCostPriceList] = useState<any[]>([]);
    const [allProducts,setAllProducts] = useState<any[]>([]);
    const showModal = async (row:DataType,type?:string,id?:number|null) => {
        await getProductAndCycle(row.id)
        await getAllProducts()
        setIsModalOpen(true);
    };


    const columns: TableProps<tabDataType>['columns'] = [
        {
            title: '商品名称',
            dataIndex: 'productName',
            key: 'productName'
          },
          {
            title: '领取数量',
            dataIndex: 'inventory',
            key: 'inventory',
            render: (_, record,index) => (
              <>
                  { record.inventory === 0 ? '无限制' : record.inventory }
              </>
            )
          },
          {
            title: '权益价',
            dataIndex: 'privilegePrice',
            key: 'privilegePrice',
          }
    ]
    
    const saveCycleAndProduct = async (data:cycleProductType) => {
        const res = await saveActivityCycleAndProduct(data) as any;
        if(res.code == 0) {
            message.success('保存成功')
            setIsModalOpen(false);
        } else {
            message.error(res.message)
        }
    }

    const isVaild = () => {
        let flag = true;
        periods.forEach((item:any)=> {
            if(!item.activityCycleProductDatas.length) {
                flag = false;
            }
        }) 
        return flag
    }
  
    const handleOk = async (confirm?:string) => {
        if(!isVaild()) {
            return message.error('请填写完整信息')
        }
        if (!confirm) {
            if (costPriceTotal > 50) {
                setTipOpen(true);
                return
            }
        }
        const curData = periods.map((item:any)=> { return {
            activityCycleProductDatas:item.activityCycleProductDatas,
            activityId:item.activityId,id:item.id,name:item.name
        }})
        await saveCycleAndProduct({
            activityId:curData[0].activityId,
            activityCycleDatas:curData as any
        })
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.select(); 
    }

    const debouncedSearch = debounce((value:string) => {
        getAllProducts(value || '')
    }, 300);

    const handleSearch = (value:string) => {
        debouncedSearch(value);
    };

    const getProductAndCycle = async (id:number) => {
        const res = await activityCycleAndProductList(id) as ResDataType;
        if(res.code == 0) {
            const {activityCycleDatas} = res.data;
            const curProductLst = activityCycleDatas.map((item:any)=> {
                return {...item,selectProduct:null,num:0,price:null}
            })
            setPeriods(curProductLst)
            setCostPriceList(curProductLst)
            curHighValueCostPrice(curProductLst)
        } 
    }

    const getAllProducts = async (name?:string) => {
        const res = await selectProductList(name) as ResDataType;
        if(res.code == 0) {
            setAllProducts(res.data.list)
            return
        }
        setAllProducts([])
    }

    const addProduct = (currentItem:any,tableIndex:number,item:any) => {
        if (!currentItem.selectProduct || ( !currentItem.num && currentItem.num != 0) || ( !currentItem.price && currentItem.price != 0)) {
            message.warning('请选择商品并输入数量和价格');
            return;
        }
        if (currentItem.activityCycleProductDatas.some((p:any) => p.productId === currentItem.selectProduct)) {
            message.warning('该商品已添加');
            return;
        }
        setPeriods(produce((draft)=>{
            const selectProduct = allProducts.find((ite:selectProductType)=> ite.productId === draft[tableIndex].selectProduct)
            draft[tableIndex].activityCycleProductDatas.push({...selectProduct,activityId:item.activityId,id:'0', inventory:draft[tableIndex].num,activityCycleId:item.id,privilegePrice:draft[tableIndex].price})
            setCostPriceList(produce((drafts)=>{
                drafts[tableIndex].activityCycleProductDatas.push({costPrice:selectProduct.costPrice})
                curHighValueCostPrice(drafts)
            }))
            draft[tableIndex].num = 0
            draft[tableIndex].selectProduct = null
            draft[tableIndex].price = null
        }))
    }

    const curHighValueCostPrice = (data:any)=> {
        let total = 0;
        data.forEach((item:any)=> {
              const maxObj = item.activityCycleProductDatas.reduce((acc:any, current:any) => {
                return acc.costPrice > current.costPrice? acc : current;
              }, item.activityCycleProductDatas[0]);
              total += maxObj?.costPrice || 0;
        }) 
        setCostPriceTotal(total)
    }

    useImperativeHandle(ref, () => ({
        open: (type:string,id:number|null,row:DataType) => showModal(row,type,id),
    }))
    return(
      <Modal maskClosable={false} width={1000} title='商品配置' footer={(_, { OkBtn, CancelBtn }) => (
        <>
          <Text>当前高价值商品成本总和为：<span style={{ color: costPriceTotal>50 ? 'red' : '#000',marginRight:'10px'}}>{costPriceTotal}</span> </Text>
          <CancelBtn />
          <OkBtn />
        </>
      )}  okText="确定" cancelText="取消" open={isModalOpen} onOk={()=>{ handleOk() }} onCancel={handleCancel}>
        <div className='mb-4'>
        {
                periods.map((item:any,tableIndex:number)=> {
                    return <div className='periodStyle' key={item.id}>
                        <div className=''>
                            <h2>{item.name}</h2>
                        </div>
                        <div className='' style={{ marginBottom:'10px' }}>
                            <p>本期商品（数量0表示无限制）</p>
                            <div className='' style={{ width:'100%',display:'flex' }}>
                                <div style={{ width:'30%' }}>
                                    <p>商品名称</p>
                                    <Select showSearch value={item.selectProduct}
                                        notFoundContent='暂无数据'
                                        placeholder='商品名称'
                                        defaultActiveFirstOption={false}
                                        suffixIcon={null}
                                        filterOption={false}
                                        onSearch={handleSearch}
                                        onChange={(e)=>{ 
                                            setPeriods(produce((draft)=>{
                                                draft[tableIndex].selectProduct = e
                                            }))
                                        }} style={{ width:'100%' }}>
                                            {
                                                allProducts.map((item:selectProductType)=> {
                                                    return <Select.Option key={item.productId} value={item.productId}>{item.productName}</Select.Option>
                                                })
                                            }
                                    </Select>
                                </div>
                                <div style={{ width:'30%' }}>
                                    <p>商品数量</p>
                                    <InputNumber placeholder='数量' style={{ width:'100%' }} onFocus={handleSelect} value={item.num} onChange={(e)=>{ 
                                        setPeriods(produce((draft)=>{
                                            draft[tableIndex].num = e
                                        }))
                                    }}  min={0} defaultValue={0} />
                                 </div>
                                 <div style={{ width:'30%' }}>
                                    <p>商品权益价</p>
                                    <InputNumber placeholder='权益价' onFocus={handleSelect} style={{ width:'100%' }} value={item.price} onChange={(e)=>{ 
                                        setPeriods(produce((draft)=>{
                                            draft[tableIndex].price = e
                                        }))
                                    }}  min={0} />
                                 </div>
                                 <div style={{ width:'10%',paddingLeft:'20px' }}>
                                    <p style={{ opacity:'0' }}>添加</p>
                                    <Button type='primary' className='ml-2' onClick={() =>{
                                    const currentItem = periods[tableIndex];
                                    
                                    addProduct(currentItem,tableIndex,item);
                                 }}>添加</Button>
                                 </div>
                                
                            </div>
                        </div>
                        <div className='bg-gray-100'>
                                {item.activityCycleProductDatas.length === 0 ? <div className='card' style={{ textAlign:'center',borderRadius:'10px' }}>暂未添加商品</div> : 
                                        <Table<tabDataType> key={tableIndex+new Date().getTime()} rowKey="id" pagination={false} columns={
                                            [
                                                ...columns,
                                                {
                                                  title: '操作',
                                                  key: 'action',
                                                  fixed: 'right',
                                                  render: (_, record,index,) => ( 
                                                        <Space size="middle">
                                                            <Button danger onClick={()=>{
                                                                setPeriods(produce((draft)=>{
                                                                    const ind = draft[tableIndex].activityCycleProductDatas.findIndex((ite:any)=> ite.productId == record.productId)
                                                                    console.log(ind)
                                                                    draft[tableIndex].activityCycleProductDatas.splice(ind,1)
                                                                }))
                                                            }}>删除</Button>
                                                        </Space>
                                                    )
                                                }
                                              ]
                                        } dataSource={item.activityCycleProductDatas} />
                                }
                        </div>
                    </div>
                })
            }

        </div>
        <Modal
            title="提示"
            open={tipOpen}
            onOk={()=>{ handleOk('confirm')  }}
            onCancel={()=>{ setTipOpen(false) }}
            okText="确认"
            cancelText="取消"
        >
            <p>当前高价值商品成本总和超过50，确定保存吗？</p>
        </Modal>
      </Modal>
    )
}

export default forwardRef(ProductsContent)